import React, { ReactElement, useEffect } from 'react';

import { Box } from '@material-ui/core';

import { logEvent } from '../../../../common/analytics/helpers/log-event';
import GenericBox from '../../../../common/components/generic-box/generic-box';
import LoginForm from '../login-form/login-form';
import { useStyles } from './login.styles';

export default function Login(): ReactElement {
  const classes = useStyles();

  useEffect(() => {
    logEvent('view_login', {});
  }, []);

  return (
    <Box className={classes.rootcontainer}>
      <GenericBox id='login'>
        <LoginForm />
      </GenericBox>
    </Box>
  );
}
